<script>
    // core components
    import {Route, Router} from "svelte-routing";
    import UserForm from "../../components/Forms/User/UserForm.svelte";
    import UserTable from "../../components/Cards/User/UserTable.svelte";
    export let location;
</script>

<Router url="users">
    <Route path="table" component="{UserTable}" />
    <Route path="create" component="{UserForm}" />
    <Route path="edit" component="{UserForm}" />
</Router>
